module.exports = __webpack_public_path__ + "img/profile-icon-bg-blue.7f47cc8f.svg";